import { useQuery } from "@tanstack/react-query";
import { getTargetareMatrice } from "@/api/endpoints/targetareMatrice";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareMatrice(versiune?: string | null) {
  return useQuery({
    queryKey: queryKeys.targetare.matrice(versiune),
    queryFn: getTargetareMatrice,
    select: (response) => response.data,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}
